import enUS from './en-us'
import frFR from './fr-fr'

export default {
  'en-US': enUS,
  'fr-FR': frFR
}
